<template>
  <div class="subpage article" ref="articleRef" style="background-color: #F7F7F7;">
    <Header v-if="$route.query.platform !== 'mini'" title="精选分享" :is-sub-page="true" ref="navBarRef"></Header>

    <div ref="articleContentRef">
      <cube-scroll
        ref="scrollRef"
        :options="scrollOptions"
        @pulling-down="onPullingDown"
        @pulling-up="onPullingUp"
      >
        <section>
          <course-list :courses="courseList"></course-list>
        </section>
      </cube-scroll>
    </div>

    <router-view/>
  </div>
</template>

<script>
import Header from '../../components/Header'
import CourseList from '@/components/CourseList'
import { queryCourseList } from '@/api/course'
export default {
  name: 'Article',
  components: {
    Header,
    CourseList
  },
  data () {
    return {
      scrollOptions: {
        pullDownRefresh: {
          txt: '刷新成功'
        },
        pullUpLoad: {
          txt: {
            more: '加载更多',
            noMore: '到底啦~'
          }
        }
      },
      courseList: [],
      curPage: 1,
      total: 0
    }
  },
  mounted () {
    // document.title = '精选分享'
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }

    this.$nextTick(() => {
      const navBarHeight = this.$refs.navBarRef ? this.$refs.navBarRef.$el.clientHeight : 0
      this.$refs.articleContentRef.style.height = (this.$refs.articleRef.clientHeight - navBarHeight) + 'px'
    })

    this.courseList.splice(0)
    if (this.$store.state.token.token !== '' && this.$store.state.token.token !== undefined) {
      this.getData()
    }
  },
  methods: {
    onPullingDown () {
      // 模拟更新数据
      this.curPage = 1
      this.courseList.splice(0)
      this.getData()

      setTimeout(() => {
        console.log('刷新数据。。。')
        this.$refs.scrollRef.forceUpdate()
      }, 1000)
    },
    onPullingUp () {
      // 模拟更新数据
      if (this.courseList.length >= this.total) {
        this.$refs.scrollRef.forceUpdate()
        return
      }
      this.curPage += 1
      this.getData()
      setTimeout(() => {
        console.log('加载数据。。。')
        this.$refs.scrollRef.forceUpdate()
      }, 1000)
    },
    getData () {
      queryCourseList({
        typeCode: '2',
        page: this.curPage,
        size: 1000
      }).then((res) => {
        this.total = res.data.total
        const records = res.data.records
        records.sort(this.compare('sort'))
        records.forEach((item, idx) => {
          this.courseList.push({
            id: item.courseId,
            title: item.name,
            url: item.cover.resUrl,
            read: item.readNum,
            comment: item.commentNum,
            type: '2'
          })
        })
      })
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    }
  }
}
</script>

<style lang="stylus">
body
  background-color #f7f7f7 !important
</style>
